const PolicyCardStyles = {
  policyCard: {
    padding: "24px",
    border: "1px solid #C9E1EC",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
    mb: 1.5,
    borderRadius: "8px",
  },
  containerOne: {
    display: "flex",
    alignItems: "center",
  },
  containerTwo: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr 1fr",
      md: "1fr 1fr 1fr 1fr",
    },
    gap: 3,
    mb: 3,
  },
  policyCardItemHeading: {
    color: "#1D252B",
    fontSize: "14px",
    fontWeight: 400,
    mb: 0.5,
    overflow: "hidden",
    fontFamily: "Noto Sans",
    textOverflow: "ellipsis",
    "@media (max-width:599px)": {
      fontSize: "16px",
    },
    "@media (min-width:600px) and (max-width:1024px)": {
      whiteSpace: "nowrap",
    },
  },
  policyCartItemContent: {
    color: "#1D252B",
    fontSize: "12px",
    fontWeight: 300,
    opacity: 0.8,
    marginTop: "0.5rem",
    "@media(max-width:599px)": {
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontFamily: '"Noto Sans"',
    },
    "@media (min-width: 1025px) and (max-width: 1366px)": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  policyCardAction: {
    textTransform: "none",
    backgroundColor: "#3AABDF",
    "&:hover": {
      backgroundColor: "#2d86b0",
    },
  },
};

export default PolicyCardStyles;
